import { createFileRoute } from '@tanstack/react-router';
import { academicSeo } from '@/components/astro/pages/academic-seo';
import { DefaultLandingPage } from '@/components/astro/pages/default-landing-page';
import { normalizeCanonicalUrl } from '@/seo/canonical';
import { seo } from '@/seo/seo';

/**
 * `/academic-1` — the classic academic ad landing page: the standard marketing
 * body (`Homepage25Body`), whose CTAs resolve `DEFAULT_CTA_LINK` and lead to
 * `/app/continue` and the early-onboarding flow there.
 *
 * Deliberately NOT an experimental route. `/academic` and `/fb/academic` run
 * `academic-landing-funnel-v1` and bucket visitors between this page and the
 * squeeze page; this URL and its `/academic-2` sibling pin one landing+funnel
 * pair each, so a campaign can send traffic straight at the combination it
 * wants. No flag is read here and the URL carries no `x-variants` cache
 * dimension — do not register it in `experimental-routes.ts` without moving
 * the whole pair.
 *
 * Cached as a plain static marketing page: it is on the `cached-routes.ts`
 * allow-list, so the `_marketing` layout's `marketingCacheHeaders()` gives it
 * the shared TTL and no `headers` export is needed here. It is also
 * country-keyed (`COUNTRY_KEYED_MARKETING_PATHS`) because `CtaButton` picks
 * its label off the free-plan country.
 *
 * Canonical points at `/academic`, the same way `/fb/academic` does: the body
 * is identical, so the three must not compete as duplicate content.
 */
export const Route = createFileRoute('/_marketing/academic-1')({
  head: () => ({
    meta: [...seo(academicSeo)],
    links: [{ rel: 'canonical', href: normalizeCanonicalUrl('/academic') }],
  }),
  component: DefaultLandingPage,
});
